import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconTouch = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 17,
	height: 21,
	viewBox: "0 0 17 21",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.9748 11.1903C15.8787 13.6301 14.9894 16.8585 13.4055 18.4423C11.3846 20.4632 5.73698 20.6168 3.88801 18.3175C2.71468 16.8585 1.80273 15.0877 1.22789 13.501C0.919578 12.65 1.37199 11.7323 2.21705 11.4082C2.96511 11.1212 3.81235 11.3838 4.26703 12.0435L5.40245 13.6908V4.58708C5.40245 3.71056 6.11301 3 6.98957 3C7.85657 3 8.56307 3.69579 8.57647 4.56271L8.63947 8.6687C10.8606 8.8808 14.0767 8.7662 14.9748 11.1903Z",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.2517 8C4.16454 7.36052 3.42969 6.13895 3.42969 4.73711C3.42969 2.67316 5.02263 1 6.98757 1C8.95257 1 10.5456 2.67316 10.5456 4.73711C10.5456 6.11658 9.83397 7.32148 8.77527 7.96894",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.49098 6.86256C1.17677 6.22742 1 5.5123 1 4.7555C1 3.9987 1.17677 3.28358 1.49098 2.64844",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3965 6.86256C12.7107 6.22742 12.8875 5.5123 12.8875 4.7555C12.8875 3.9987 12.7107 3.28358 12.3965 2.64844",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIconTouch;
